import React, { useEffect, useState } from "react";
import {
  TableHead,
  TableBody,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Box,
  Pagination,
  Button,
  FormControl,
  Autocomplete,
  TextField,
  Typography,
} from "@mui/material";
import CustomForm from "../UI/CustomForm/CustomForm";
import { useSelector, useDispatch } from "react-redux";
import { setNewConstants } from "../../store/redux/constants";
import "./LoanProductsAssign.scss";
import CustomLoansForm from "../UI/CustomLoansForm/CustomLoansForm";

const LoanProductsAssign = ({ products, selectedProductEligiblity, maxAmtInputError, handleEligiblityProductChange, errors, maxEligibleAmt, handleMaxEligibleAmtChange, handleMakeUserEligible, viewReports, setViewReports, isLoading}) => {
  
  const dispatch = useDispatch();
  
  const [formValues, setFormValues] = useState({
    addproduct: products
  });

  const [viewAssignLoanProducts, setViewAssignLoanProducts] = useState(false);

  const handleViewAssignLoanProducts = async() => {
    setViewAssignLoanProducts(!viewAssignLoanProducts);
  }
  
  useEffect(()=> {
    dispatch(setNewConstants({ formSelectData: { addproduct: products } }));
  },[products])

  return (
    <Box>
      <Box className="d-flex justify-content-end mb-2 w-100">
        <Typography
          sx={{
            fontFamily: "'Nunito'",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "21.4825px",
            color: "#3A3A3A",
          }}
          className=""
        >
          {/* Assign Loan Products */}
        </Typography>

        <Button
          className="fs-size-12 paiy-blue text-white"
          variant="contained"
          color="primary"
          sx={{ marginRight:'10px' }}
          onClick={()=> handleViewAssignLoanProducts()}
        >
            {viewAssignLoanProducts ? 'Hide' : 'View'} Assign Loan Products
        </Button>
        
        <Button
          className="fs-size-12 paiy-blue text-white"
          variant="contained"
          color="primary"
          onClick={()=> setViewReports(!viewReports)}
        >
            View Reports
        </Button>
      </Box>
      {viewAssignLoanProducts && <Box className="p-4">
        {/* <CustomForm */}
        <CustomLoansForm
          // conditionalFields={conditionalFields}
          formValues={formValues}
          formName={"assignloanproducts"}
          buttonText={"Submit"}
          onSubmit={handleMakeUserEligible}
          loadingButtonText={"Adding Card ..."}
        />

        {/* <Box className="d-flex gap-3">
          <Button
            className="fs-size-12 paiy-green text-white"
            variant="contained"
            disabled={ isLoading ? true : false}
            // color="success"
            onClick={handleMakeUserEligible}
          >
            { isLoading ? "Loading..." : "Make user eligible for loan" }
          </Button>
        </Box> */}
      </Box>}
    </Box>
  );
};
export default LoanProductsAssign;
